<template>
    <div class="h-full flex flex-col justify-center py-12">
        <div class="relative sm:mx-auto sm:w-full sm:max-w-md">
            <div
                class="relative bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
            >
                <div class="flex items-center justify-center space-x-4">
                    <h1
                        class="py-4 text-5xl font-bold tracking-wide text-blue-500"
                    >
                        Agents
                    </h1>
                    <span>|</span>
                    <small class="tracking-wide">OpenCDLJobs</small>
                </div>
                <hr class="py-4 border-blue-200" />

                <form
                    class="space-y-6 py-4"
                    @submit.prevent="
                        form.post(route('agent.login', { intended }))
                    "
                >
                    <div>
                        <label
                            for="email"
                            class="block text-sm font-medium text-gray-700"
                        >
                            Email address
                        </label>
                        <div class="mt-1">
                            <input
                                v-model="form.email"
                                id="email"
                                name="email"
                                type="email"
                                autocomplete="email"
                                class="shadow-sm border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm rounded-md"
                                required
                            />
                            <div
                                class="text-xs text-red-500 mt-1 tracking-wide"
                                v-if="form.errors.email"
                                v-text="form.errors.email"
                            ></div>
                        </div>
                    </div>

                    <div>
                        <label
                            for="password"
                            class="block text-sm font-medium text-gray-700"
                        >
                            Password
                        </label>
                        <div class="mt-1 relative">
                            <div
                                v-show="form.password"
                                class="absolute inset-y-0 right-0 flex items-center px-2"
                            >
                                <input
                                    class="hidden"
                                    ref="toggle_password"
                                    id="toggle"
                                    type="checkbox"
                                    @change="togglePasswordVisibility"
                                />
                                <label
                                    class="bg-gray-300 hover:bg-gray-400 rounded px-2 py-1 text-sm text-gray-600 font-mono cursor-pointer js-password-label"
                                    for="toggle"
                                    ref="toggle_lable"
                                ></label>
                            </div>
                            <input
                                v-model="form.password"
                                ref="password_field"
                                id="password"
                                name="password"
                                type="password"
                                autocomplete="current-password"
                                class="shadow-sm border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm rounded-md"
                                required
                            />
                            <!-- <div v-if="form.errors.password" v-text="form.errors.password"></div> -->
                        </div>
                    </div>

                    <div class="flex items-center justify-between">
                        <!-- <div class="flex items-center">
                  <input
                    v-model="form.remember"
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label
                    for="remember-me"
                    class="ml-2 block text-sm text-gray-900"
                  >
                    Remember me
                  </label>
                </div> -->

                        <!-- <div class="text-sm">
                  <a
                    href="#"
                    class="font-medium text-blue-600 hover:text-blue-500"
                  >
                    Forgot your password?
                  </a>
                </div> -->
                    </div>

                    <div>
                        <button
                            type="submit"
                            class="w-1/2 float-right flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition"
                        >
                            Log in
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useForm } from "@inertiajs/inertia-vue3";
import { ref, onMounted } from "vue";

const route = window.route;
const toggle_lable = ref(null);
const toggle_password = ref(null);
const password_field = ref(null);

onMounted(() => {
    toggle_lable.value.innerText = "show";
    toggle_password.value.checked = true;
});

function togglePasswordVisibility() {
    if (toggle_password.value.checked) {
        toggle_lable.value.innerText = "show";
        password_field.value.type = "password";
    } else {
        toggle_lable.value.innerText = "hide";
        password_field.value.type = "text";
    }

    password_field.value.focus();
}

const form = useForm({
    email: "",
    password: "",
    remember: false,
});

const intended = new URLSearchParams(window.location.search).get("intended");
</script>
